import { Error } from '../types/error.types';

export const TPP = 'TPP';
export const TPP_TO_BE = 'TPP_TO_BE';
export const NON_TPP = 'NON_TPP';

export type ProvisioningStatus = typeof TPP | typeof TPP_TO_BE | typeof NON_TPP;

export type CreateUserResponse = {
  payload: {
    response: {
      errors?: Error[];
      message: string;
    };
    status: number;
  };
  error: boolean;
  type: string;
};

export type CreateUserPayload = {
  email?: string;
  password?: string;
  termsOfUse?: string;
  provisioningStatus?: ProvisioningStatus;
  name?: string;
  surname?: string;
  companyName?: string;
  country?: string;
  description?: string;
  captchaResponse?: string;
  attachment?: any;
};

export type User = {
  email: string;
  password: string;
  firstName: string;
  lastName: string;
  country: string;
};

export type UserResponse = {
  payload: User | null;
  error: boolean;
  type: string;
};

export type UpdateUserPayload = {
  email?: string;
  password?: string;
  firstName?: string;
  lastName?: string;
  country?: string;
};

export type UpdateUserResponse = {
  payload: {
    response: {
      errors?: Error[];
      user: User;
    };
    status: number;
  };
  error: boolean;
  type: string;
};

export type ResetPasswordResponse = {
  payload: {
    response: {};
    status: number;
  };
  error: boolean;
  type: string;
};

export type ResetPasswordPayload = {
  email?: string;
};

export type ValidateTokenResponse = {
  payload: {};
  error: boolean;
  type: string;
};

export type ChangePasswordResponse = {
  payload: {
    response: {};
    status: number;
  };
  error: boolean;
  type: string;
};

export type ChangePasswordPayload = {
  token?: string;
  password?: string;
  captchaResponse?: string;
};

export type ActivateEmailResponse = {
  payload: {};
  error: boolean;
  type: string;
};
